export const deleteAdvert = (payload?: any) => ({
    type: "@saga/DELETE_ADVERT",
    payload
});

